type Price = 249;
const price: Price = 249;
export default price;
